var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3131 31H50.6887M25.1316 80H64.8703C75.3358 80 79.5069 74.085 79.9998 66.875L81.9716 37.965C82.0945 36.1724 81.8178 34.3756 81.1585 32.6856C80.4993 30.9957 79.4716 29.4485 78.1389 28.1396C76.8062 26.8308 75.1969 25.7881 73.4103 25.0761C71.6238 24.3641 69.6981 23.9979 67.7521 24C65.4391 24 63.3156 22.775 62.2539 20.885L59.5238 15.81C57.7795 12.625 53.2293 10 49.3616 10H40.6782C36.7726 10 32.2223 12.625 30.4781 15.81L27.7479 20.885C26.6862 22.775 24.5628 24 22.2497 24C14.0214 24 7.4994 30.405 8.03026 37.965L10.002 66.875C10.4571 74.085 14.666 80 25.1316 80Z",
    stroke: "#C8D8F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71C53.8123 71 61 63.8123 61 55C61 46.1877 53.8123 39 45 39C36.1877 39 29 46.1877 29 55C29 63.8123 36.1877 71 45 71Z",
    stroke: "#C8D8F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 55H51M45 61V49",
    stroke: "#C8D8F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2c7a16cf38673d57b28dda41483f604f.svg";
export { ForwardRef as ReactComponent };